import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useRef, useEffect } from 'react';
import customTwMerge from 'utils/twMerge';
import Loading from 'assets/json/lottie-loading.json';
import Hourglass from 'assets/json/lottie-hourglass.json';

type Props = {
  isFullPage?: boolean;
  containerStyle?: string;
  lottieStyle?: string;
  speed?: number;
  animation?: 'hourglass' | 'loading';
};

export default function CLottie({
  isFullPage,
  containerStyle,
  lottieStyle,
  speed = 2,
  animation,
}: Props) {
  const lottieRef = useRef<LottieRefCurrentProps>();

  const animationData = animation === 'hourglass' ? Hourglass : Loading;

  useEffect(() => {
    lottieRef.current?.setSpeed(speed);
  }, []);

  return (
    <>
      {isFullPage ? (
        <div className={customTwMerge('flex h-full flex-1', containerStyle)}>
          <Lottie
            // @ts-expect-error lottieRef
            lottieRef={lottieRef}
            animationData={animationData}
            className={customTwMerge(
              'm-auto h-[80px] w-[80px] rounded-full bg-neutral-0 p-2 drop-shadow-md',
              lottieStyle
            )}
          />
        </div>
      ) : (
        <Lottie
          // @ts-expect-error lottieRef
          lottieRef={lottieRef}
          animationData={animationData}
          className={customTwMerge('', lottieStyle)}
        />
      )}
    </>
  );
}
